module.exports = __webpack_public_path__ + "static/img/fingerpost_buy_3.7a0bd9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_buy_3.jpg
// module id = bxl+
// module chunks = 0